import { render, staticRenderFns } from "./logoRepense.vue?vue&type=template&id=01a0d0e0&scoped=true&"
import script from "./logoRepense.vue?vue&type=script&lang=js&"
export * from "./logoRepense.vue?vue&type=script&lang=js&"
import style0 from "./logoRepense.vue?vue&type=style&index=0&id=01a0d0e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a0d0e0",
  null
  
)

component.options.__file = "logoRepense.vue"
export default component.exports